<template>
  <div>
    <b-tabs v-model="activeSubTab" nav-class="mb-3" class="mb-3">
      <b-tab title="Pelaku Usaha">
        <form-wawancara-narasumber
          :value="value.pelaku_usaha"
          id-prefix="pelaku-usaha-"
          :tim-penilai-options="timPenilaiOptions"
          :is-loading-tim-penilai="isLoadingTimPenilai"
          :tim-penilai-error="timPenilaiError"
          @input="updateSubForm('pelaku_usaha', $event)"
        />
      </b-tab>
      <b-tab title="Masyarakat">
        <form-wawancara-narasumber
          :value="value.masyarakat"
          id-prefix="masyarakat-"
          :tim-penilai-options="timPenilaiOptions"
          :is-loading-tim-penilai="isLoadingTimPenilai"
          :tim-penilai-error="timPenilaiError"
          @input="updateSubForm('masyarakat', $event)"
        />
      </b-tab>
    </b-tabs>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button
          type="button"
          variant="outline-primary"
          class="mr-2 mb-2"
          @click="showPreviewModal = true"
        >
          <i class="fa fa-eye"></i> Preview Wawancara
        </b-button>
        <b-button variant="success" class="mr-2 mb-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" class="mb-2" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>

    <document-preview-modal v-model="showPreviewModal" title="Preview Wawancara" />
  </div>
</template>

<script>
import axios from 'axios'
import DocumentPreviewModal from '@/components/DocumentPreviewModal/DocumentPreviewModal.vue'
import formWawancaraNarasumber from './formWawancaraNarasumber.vue'
import { createEmptyWawancaraNarasumber } from './wawancaraQuestions'

export default {
  name: 'FormWawancaraPusat',
  components: { formWawancaraNarasumber, DocumentPreviewModal },
  props: {
    value: {
      type: Object,
      default: () => ({
        pelaku_usaha: createEmptyWawancaraNarasumber(),
        masyarakat: createEmptyWawancaraNarasumber(),
      }),
    },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      activeSubTab: 0,
      timPenilaiOptions: [],
      isLoadingTimPenilai: false,
      timPenilaiError: '',
      showPreviewModal: false,
    }
  },
  mounted() {
    this.getTimPenilai()
  },
  methods: {
    updateSubForm(key, subValue) {
      this.$emit('input', { ...this.value, [key]: subValue })
    },
    buildNarasumberPayload(key) {
      const data = this.value[key] || createEmptyWawancaraNarasumber()
      return {
        tanggal_wawancara: data.tanggal_wawancara,
        waktu_mulai: data.waktu_mulai,
        waktu_selesai: data.waktu_selesai,
        zona_waktu: data.zona_waktu,
        lokasi: data.lokasi,
        pewawancara: data.pewawancara,
        nama_narasumber: data.nama_narasumber,
        alamat_narasumber: data.alamat_narasumber,
        no_surat_tugas_kuasa: data.no_surat_tugas_kuasa,
        jawaban_pertanyaan: data.jawaban_pertanyaan,
        catatan: data.catatan,
      }
    },
    buildPayloadPelakuUsaha() {
      return this.buildNarasumberPayload('pelaku_usaha')
    },
    buildPayloadMasyarakat() {
      return this.buildNarasumberPayload('masyarakat')
    },
    buildWawancaraPayload() {
      return {
        pelaku_usaha: this.buildPayloadPelakuUsaha(),
        masyarakat: this.buildPayloadMasyarakat(),
      }
    },
    async getTimPenilai() {
      this.isLoadingTimPenilai = true
      this.timPenilaiError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/user?filter=roles,contains,Verifikator;nama_upt,=,PUSAT&limit=0`,
          { headers: { Authorization: `Bearer ${this.user.accessToken}` } },
        )
        this.timPenilaiOptions = response.data.data || []
      } catch (error) {
        this.timPenilaiError = 'Daftar Tim Penilai gagal dimuat.'
      } finally {
        this.isLoadingTimPenilai = false
      }
    },
  },
}
</script>
